export const frontendUrls = {
    login: "/login",
    dashboard: "/",
    rawData: "/data",
};

export const backendUrls = {
    
};